<template>
  <div class="dashboard-wrapper">
    <div class="dashboard-section map-section">
      <map-componets 
        v-if="projectData && rainData && rainList" 
        :project-data="projectData" 
        :rain-data="rainData" 
        :rain-list="rainList" 
      />
    </div>

    <div class="dashboard-section chart-section">
      <instrument-status 
        v-if="instrumentList" 
        :instruments="instrumentList" 
        :show-table="false" 
        :show-chart="true" 
      />
    </div>

    <div class="dashboard-section split-section">
      <el-row :gutter="15" type="flex" class="equal-height-row">        
        <el-col :xs="24" :sm="24" :md="12" :lg="12" class="flex-col">
          <instrument-status 
            v-if="instrumentList" 
            :instruments="instrumentList" 
            :show-table="true" 
            :show-chart="false" 
          />
        </el-col>

        <el-col :xs="24" :sm="24" :md="12" :lg="12" class="flex-col">
          <system-health 
            v-if="battList && loggerList" 
            :batt-list="battList" 
            :logger-list="loggerList" 
          />
        </el-col>
      </el-row>
    </div>

    <div class="dashboard-section sms-section">
      <SMS type="simplify" /> 
    </div>
  </div>
</template>

<script>
import InstrumentStatus from './instrumentStatus.vue';
import SystemHealth from './systemHealth.vue';
import MapComponets from '@/components/map/MapComponets.vue';
import SMS from './SMS.vue';
import { isThsrProject } from '@/lib/base/project';

export default {
  components: {
    InstrumentStatus,
    SystemHealth,
    MapComponets,
    SMS,
  },
  data() {
    return {
      projectData: null,
      rainData: null,
      instrumentList: null,
      rainList: null,
      battList: null,
      loggerList: null,
    };
  },
  computed: {
    selectedProject() {
      return this.$store.getters['project/selectedProject'];
    },
  },
  mounted() {
    if (isThsrProject(this.selectedProject._id)) {
      this.getProject();
      this.getAlertMessage();
      this.getRainData();
    }
    else if (this.selectedProject.project_id.includes('臺鐵邊坡監測系統')) {
      this.$router.replace({ name: 'Dashboard-TRA' });
    }
    else {
      this.$router.replace({ name: 'DashboardOld' });
    }
  },
  methods: {
    async getProject() {
      try {
        const res = await this.$axios({
          category: 'project',
          method: 'get',
          apiName: `${this.selectedProject._id}/area-station-instrument`,
        });

        this.projectData = res.data;
        const areas = res.data.area || [];

        this.instrumentList = areas
          .filter(area => area.name !== 'Retired Instruments')
          .flatMap(area => 
            (area.station || []).flatMap(station => station.instrument || []),
          );

        this.battList = areas
          .filter(area => area.name === '維護資訊')
          .flatMap(area => 
            (area.station || []).flatMap(station => station.instrument || []),
          );

        const documentRes = await this.$axios({
          category: 'project',
          method: 'get',
          apiName: 'document',
        });

        const documents = documentRes.data || [];
        // 找出 name 包含 _Data.dat 的 item
        this.loggerList = documents.filter(doc => doc.name && doc.name.includes('_Data.dat'));
        
        // 找出 name 不包含 .dat 的 item 並且要以 TK 開頭
        const additionalGateways = documents.filter(doc => doc.name && !doc.name.includes('.dat') && doc.name.startsWith('TK'));
        this.loggerList.push(...additionalGateways);

        // 找出 name 包含 .dat 的 item 要以 TK 開頭並且不包含 _Data.dat & _ & - & TK236 加入到 gatewayList
        const additionalGateways_new = documents.filter(doc => doc.name && doc.name.includes('.dat') && doc.name.startsWith('TK') && !doc.name.includes('_Data.dat') && !doc.name.includes('_') && !doc.name.includes('-') && !doc.name.includes('TK236'));
        this.loggerList.push(...additionalGateways_new);
      } catch (e) {
        console.error(e);
      }
    },

    async getAlertMessage() {
      try {
        const daysAgo = 1;
        const res = await this.$axios({
          method: 'get',
          apiName: 'sms',
          params: {
            daysAgo,
          },
        });
        res.data = res.data.filter(item => item.content && item.content.includes('超過') && !item.content.includes('Vdc'));
        // console.log('Alert Message:', res.data);
      } catch (e) {
        console.error(e);
      }
    },

    async getRainData() {
      const role = this.$store.getters['user/details']?.roles;
      if (role !== 'admin' && role !== 'thsr') return;
      try {
        const res = await this.$axios({
          category: 'project',
          method: 'get',
          apiName: `5ec2aed45ff71e000adc6119/data/last/storm/${Date.now()}`,
          useUrl: 'https://api-thsr-rain.geosupply.com.tw/',
        });

        this.rainData = res.data;
        // console.log('Rain Data:', res.data);

        const RainRes = await this.$axios({
          category: 'project',
          method: 'get',
          apiName: '5ec2aed45ff71e000adc6119/area-station-instrument',
          useUrl: 'https://api-thsr-rain.geosupply.com.tw/',
        });

        const areas = RainRes.data.area || [];

        // 只保留 instrument.status, instrument.latestVersion.name, instrument.latestVersion.coordinates
        this.rainList = areas.flatMap(area => 
          (area.station || []).flatMap(station => station.instrument || []),
        ).map(instrument => ({
          status: instrument.status,
          name: instrument.latestVersion?.name,
          coordinates: instrument.latestVersion?.coordinates,
        }));

        // console.log('Rain List:', this.rainList);

      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped>
.dashboard-wrapper {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.dashboard-section {
  width: 100%;
}

.equal-height-row {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}

.flex-col {
  display: flex;
  flex-direction: column;
}
</style>